import React, { useState } from "react";
import axios from "axios";
import { resources } from "../Resourses/Resources";
import { toast } from "react-toastify";
import RotatingSpinner from "../Resourses/RotatingSpinner";

const dept = ["ECE", "CSE", "EEE", "MECH", "CIVIL", "CSE"];
const reg = ["R16", "R17", "R18", "R19", "R20"];
const academicYear = [];
const year = new Date().getFullYear();
for (let i = year - 5; i <= year; i++) {
  academicYear.push(i);
}
for (let i = year + 1; i <= year + 5; i++) {
  academicYear.push(i);
}

const successMessage = (message) => {
  toast.success(message, {
    position: toast.POSITION.TOP_CENTER,
    toastId: "success1",
    className: "success",
  });
};
const errorMessage = (message) => {
  toast.error(message, {
    position: toast.POSITION.TOP_CENTER,
    toastId: "error1",
    className: "error",
  });
};

const EmployeeFeedback = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [EmployeeFeedback, setEmployeeFeedback] = useState({
    employerName: "",
    designation: "",
    organiztion: "",
    academicYear: "",
    industrialRequirements: "",
    significanceOfGlobalEmployement: "",
    leaderShipSkills: "",
    workQualities: "",
    technologicalAdvancements: "",
    scopeOfEmployabilty: "",
    ictTools: "",
    passionWork: "",
    creativity: "",
    aspirationsInStudents: "",
    anySuggestions: "",
  });

  const handleEmployeeFeedbackDetails = (e) => {
    const { value, name } = e.target;
    setEmployeeFeedback({ ...EmployeeFeedback, [name]: value });
  };

  const handleSubmitDataToBackend = async () => {
    console.log(EmployeeFeedback);
    setIsLoading(true);
    try {
      const response = axios.post(
        resources.APPLICATION_URL + "saveEmployeeFeedBackDetails",
        EmployeeFeedback
      );
      if (response.data) {
        successMessage("Thank you for your valuable feedback");
      } else {
        errorMessage("Something went wrong. Please try again later");
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <RotatingSpinner />
      ) : (
        <div style={{ padding: "50px" }}>
          <div className="teacher_feedback_heading_container">
            <h1 className="teacher_form_heading">
              Employer Feedback on Academic Performance and Institution Ambience
            </h1>
          </div>
          <form className="teacher_feedback_form_main_container">
            <div className="teacher_feedback_form_container">
              <label htmlFor="name">1.Name of the Employer</label>
              <input
                onChange={(e) => handleEmployeeFeedbackDetails(e)}
                type="text"
                id="employerName"
                name="employerName"
                value={EmployeeFeedback.employerName}
                required
                placeholder="Enter employerName"
              />
            </div>
            <div className="teacher_feedback_form_container">
              <label htmlFor="name">2.Designation</label>
              <input
                onChange={(e) => handleEmployeeFeedbackDetails(e)}
                type="email"
                id="designation"
                name="designation"
                value={EmployeeFeedback.designation}
                required
                placeholder="Enter Designation"
              />
            </div>
            <div className="teacher_feedback_form_container">
              <label htmlFor="name">3.Organization</label>
              <input
                onChange={(e) => handleEmployeeFeedbackDetails(e)}
                type="text"
                id="organiztion"
                name="organiztion"
                required
                placeholder="Enter Designation"
              />
            </div>
            <div className="teacher_feedback_form_container">
              <label>4.Academic Year</label>
              <select name="academicYear">
                <option>Please select...</option>
                {academicYear
                  .filter((each) => each !== "")
                  .map((each) => (
                    <option key={each} value={EmployeeFeedback.academicYear}>
                      {each}
                    </option>
                  ))}
              </select>
            </div>

            <div className="teacher_feedback_form_container">
              <label>
                5.How efficient does the curriculum cater to the Industrial
                Requirements
              </label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="industrialRequirements"
                  id="industrialRequirements"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="courseContent"
                  id="courseContent"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="courseContent"
                  id="courseContent"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="courseContent"
                  id="courseContent"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="courseContent"
                  id="courseContent"
                />
                <span>Bellow Average</span>
              </div>
            </div>

            <div className="teacher_feedback_form_container">
              <label>6.Significance of courses towards global employment</label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="significanceOfGlobalEmployement"
                  id="significanceOfGlobalEmployement"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="significanceOfGlobalEmployement"
                  id="significanceOfGlobalEmployement"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="significanceOfGlobalEmployement"
                  id="significanceOfGlobalEmployement"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="significanceOfGlobalEmployement"
                  id="significanceOfGlobalEmployement"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="significanceOfGlobalEmployement"
                  id="significanceOfGlobalEmployement"
                />
                <span>Bellow Average</span>
              </div>
            </div>

            <div className="teacher_feedback_form_container">
              <label>7.Organization promotes leadership skills</label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="leaderShipSkills"
                  id="leaderShipSkills"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="leaderShipSkills"
                  id="leaderShipSkills"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="leaderShipSkills"
                  id="leaderShipSkills"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="leaderShipSkills"
                  id="leaderShipSkills"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="leaderShipSkills"
                  id="leaderShipSkills"
                />
                <span>Bellow Average</span>
              </div>
            </div>

            <div className="teacher_feedback_form_container">
              <label>
                8.Inculcation of professional ethics and team work qualities
              </label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="workQualities"
                  id="workQualities"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="workQualities"
                  id="workQualities"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="workQualities"
                  id="workQualities"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="workQualities"
                  id="workQualities"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="workQualities"
                  id="workQualities"
                />
                <span>Bellow Average</span>
              </div>
            </div>

            <div className="teacher_feedback_form_container">
              <label>
                9.Inter- Disciplinary subjects offered are up to mark regarding
                technological advancements
              </label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="technologicalAdvancements"
                  id="technologicalAdvancements"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="technologicalAdvancements"
                  id="technologicalAdvancements"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="technologicalAdvancements"
                  id="technologicalAdvancements"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="technologicalAdvancements"
                  id="technologicalAdvancements"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="technologicalAdvancements"
                  id="technologicalAdvancements"
                />
                <span>Bellow Average</span>
              </div>
            </div>

            <div className="teacher_feedback_form_container">
              <label>10.Provides vast scope for Employability</label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="scopeOfEmployabilty"
                  id="scopeOfEmployabilty"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="scopeOfEmployabilty"
                  id="scopeOfEmployabilty"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="scopeOfEmployabilty"
                  id="scopeOfEmployabilty"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="scopeOfEmployabilty"
                  id="scopeOfEmployabilty"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="scopeOfEmployabilty"
                  id="scopeOfEmployabilty"
                />
                <span>Bellow Average</span>
              </div>
            </div>

            <div className="teacher_feedback_form_container">
              <label>11.Practical exposure to ICT tools</label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="ictTools"
                  id="ictTools"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="ictTools"
                  id="ictTools"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="ictTools"
                  id="ictTools"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="ictTools"
                  id="ictTools"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="ictTools"
                  id="ictTools"
                />
                <span>Bellow Average</span>
              </div>
            </div>

            <div className="teacher_feedback_form_container">
              <label>12.Builds passion towards work</label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="passionWork"
                  id="passionWork"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="passionWork"
                  id="passionWork"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="passionWork"
                  id="passionWork"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="passionWork"
                  id="passionWork"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  onChange={(e) => handleEmployeeFeedbackDetails(e)}
                  style={{ width: "15px" }}
                  type="radio"
                  name="passionWork"
                  id="passionWork"
                />
                <span>Bellow Average</span>
              </div>
            </div>

            <div className="teacher_feedback_form_container">
              <label>
                13.Flexibility towards innovativeness and creativity
              </label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="creativity"
                  id="creativity"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="creativity"
                  id="creativity"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="creativity"
                  id="creativity"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="creativity"
                  id="creativity"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="creativity"
                  id="creativity"
                />
                <span>Bellow Average</span>
              </div>
            </div>

            <div className="teacher_feedback_form_container">
              <label>
                14.Induction of research zeal and future aspirations in students
              </label>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="aspirationsInStudents"
                  id="aspirationsInStudents"
                />
                <span>Excellent</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="aspirationsInStudents"
                  id="aspirationsInStudents"
                />
                <span>Very Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="aspirationsInStudents"
                  id="aspirationsInStudents"
                />
                <span>Good</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="aspirationsInStudents"
                  id="aspirationsInStudents"
                />
                <span>Average</span>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  style={{ width: "15px" }}
                  type="radio"
                  name="aspirationsInStudents"
                  id="aspirationsInStudents"
                />
                <span>Bellow Average</span>
              </div>
            </div>
            <div className="teacher_feedback_form_container">
              <label htmlFor="name">Any Suggestions</label>
              <textarea
                cols={45}
                rows={5}
                type="text"
                onChange={(e) => handleEmployeeFeedbackDetails(e)}
                id="anySuggestions"
                name="anySuggestions"
                value={EmployeeFeedback.anySuggestions}
                required
                placeholder="Enter Any Suggestions"
              />
            </div>
            <button
              onClick={() => handleSubmitDataToBackend()}
              className="submit_btn"
              type="button"
            >
              Submit
            </button>
          </form>
        </div>
      )}
    </>
  );
};

export default EmployeeFeedback;
